import { lazy, useEffect, useState } from "react"
import Spinner from "../../components/Spinner"
import jwtDecode from "jwt-decode"

const StudentHelp = lazy(() => import("../Help/Help"))
const TutorHelp = lazy(() => import("../TutorPortal/Help/Help"))
const SchoolHelp = lazy(() => import("../SchoolPortal/Help/Help"))

export default function RootAlerts() {
  const [role, setRole] = useState("")

  useEffect(() => {
    const role = jwtDecode(localStorage.getItem("token")).role
    setRole(role)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!role) return <Spinner type="child" />
  if (role === "Student") return <StudentHelp />
  if (role === "Tutor" || role === "Senior Tutor") return <TutorHelp />
  if (role === "School Manager") return <SchoolHelp />
}
